import { useTranslation } from "react-i18next";
import { SmallModal } from "../../SmallModal";
import { Fragment, useEffect, useState } from "react";
import { CheckIcon, ClockIcon, DocumentDuplicateIcon, XMarkIcon } from "@heroicons/react/24/outline";
import Button from "../../Button";

interface Props {
  info: {
    show: boolean;
    token: string;
  };
  onClose: () => void;
}

export const ObtainAuthorizationTokenModal: React.FC<Props> = ({
  info,
  onClose,
}) => {
    const { t } = useTranslation();
    //const dispatch = useDispatch<AppDispatch>();
    const [copied, setCopied] = useState(false);
    
    const closeModal = () => {
        onClose();
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(info.token);
            setCopied(true);
            //setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
        } catch (err) {
            console.error('Failed to copy token: ', err);
        }
    };

    return(
        <div>
            <SmallModal
                isOpen={info.show}
                onClose={closeModal}
                label={t("OBTAIN_TOKEN")}
                hideCancelButton={true}
                thirdButton={{
                    label: t("CLOSE"),
                    icon: <XMarkIcon />,
                    onClick: closeModal
                }}
                saveButton={{
                    label: copied ? t("COPIED") : t("COPY"),
                    icon:  copied ? <CheckIcon/> : <DocumentDuplicateIcon />,
                    onClick: handleCopy,
                    isTerciary: !copied
                }}
            >
                <div className="w-full flex flex-wrap">
                    <Fragment>
                        <div className="text-lg font-bold text-black pl-3 mt-2 mb-3">
                            {t("AUTHORIZATION_TOKEN")}
                        </div>
                        <div className="appearance-none block w-full border border-gray-200 text-gray-700 rounded px-4 mb-3 leading-tight focus:outline-none focus:border-blue mx-3">
                            <p className="py-4 break-all">{info.token}</p>
                        </div>
                       <div>
                            <p className="pl-3 mt-3 text-gray-500">{t("GET_AUTHORIZATION_TOKEN_MESSAGE")}</p>
                        </div>
                    </Fragment>
                </div>
            </SmallModal>
        </div>
    )
}